module.exports = {
      id: "refresh-icon-usage",
      viewBox: "0 0 18 18",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#refresh-icon",
      toString: function () {
        return this.url;
      }
    }